import React from 'react';
import Link from 'next/link';
import { Button } from '@avila-tek/ui/src';
import { useMutation } from '@apollo/client';
import { useNotify, useShopCart } from '../../hooks';
import { CLEAN_SHOP_CART } from '../../graphql/mutation';
import { ShopCart } from '../../models';

function ShopcartButtons() {
  const [shopCart, setShopCart] = useShopCart();
  const notify = useNotify();

  const [disabled, setDisabled] = React.useState(false);

  const [cleanShopCartMutation] = useMutation<{
    cleanShopCart: ShopCart;
  }>(CLEAN_SHOP_CART);

  const cleanShopCart = async () => {
    try {
      if (disabled) return;
      setDisabled(true);
      const { data } = await cleanShopCartMutation({
        variables: {
          data: {
            shopCartId: shopCart._id,
          },
        },
      });
      if (data.cleanShopCart._id) {
        notify('Carrito limpiado', 'success');
        setShopCart(data.cleanShopCart);
      } else {
        notify('No se pudo limpiar el carrito', 'error');
      }
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setDisabled(false);
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <Link href="/app/checkout">
        <Button>Pagar</Button>
      </Link>
      <Button
        onClick={cleanShopCart}
        className="bg-white border border-danger-200 text-danger-200"
      >
        Limpiar carrito
      </Button>
    </div>
  );
}

export default ShopcartButtons;
